import { useHistory } from "react-router-dom";

import ArrowRight from "@/assets/icons/arrow-right.svg";
import useSearchParams from "@/hooks/useSearchParams";
import { ROUTES } from "@/routes_new";
import Button from "@components/Button";
import {
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "@components/Modal";
import Modal, { ModalProps } from "@components/Modal/Modal";

import styles from "./ArticleModal.module.css";

const ArticleModal = ({
  description,
  nextArticle,
  title,
  cta,
  ...rest
}: Omit<ModalProps, "children"> & {
  cta?: { label?: string; href?: string };
  description?: string;
  nextArticle?: string;
  title?: string;
}) => {
  const history = useHistory();
  const [searchParams] = useSearchParams<{ article: string }>();

  return (
    <Modal {...rest}>
      <ModalHeader className={styles["guide-modal__header"]}>
        <ModalTitle className={styles["guide-modal__header__title"]}>
          {title}
        </ModalTitle>
      </ModalHeader>

      <ModalContent>
        {description && (
          <div
            className={styles["guide-modal__description"]}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </ModalContent>

      {(cta || nextArticle) && (
        <ModalFooter className={styles["guide-modal__footer"]}>
          {cta ? <Button href={cta.href}>{cta.label}</Button> : <div />}

          {nextArticle && (
            <Button
              type="button"
              icon={ArrowRight}
              variant="secondary"
              iconPlacement="after"
              onClick={() => {
                history.push({
                  pathname: ROUTES.DASHBOARD,
                  search: new URLSearchParams({
                    ...searchParams,
                    article: nextArticle,
                  }).toString(),
                });
              }}
            >
              {L.DASHBOARD__GUIDE_MODAL__NEXT_GUIDE}
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

export default ArticleModal;
